import { ViewGridIcon, ViewListIcon } from "@heroicons/react/outline";
import { memo } from "react";

export type ViewMode = "grid" | "list";

interface ViewToggleProps {
  currentView: ViewMode;
  onViewChange: (view: ViewMode) => void;
}

const ViewToggle: React.FC<ViewToggleProps> = memo(({ currentView, onViewChange }) => (
  <div className="flex items-center rounded-md border border-gray-200 bg-white p-0.5">
    <button
      onClick={() => onViewChange("grid")}
      className={`flex items-center gap-1.5 rounded px-2.5 py-1.5 text-sm font-medium transition-all ${
        currentView === "grid"
          ? "bg-gray-100 text-gray-900 shadow-sm"
          : "text-gray-600 hover:text-gray-900"
      }`}
      aria-label="Grid view"
      aria-pressed={currentView === "grid"}
    >
      <ViewGridIcon className="h-4 w-4" />
      <span className="hidden sm:inline">Grid</span>
    </button>
    <button
      onClick={() => onViewChange("list")}
      className={`flex items-center gap-1.5 rounded px-2.5 py-1.5 text-sm font-medium transition-all ${
        currentView === "list"
          ? "bg-gray-100 text-gray-900 shadow-sm"
          : "text-gray-600 hover:text-gray-900"
      }`}
      aria-label="List view"
      aria-pressed={currentView === "list"}
    >
      <ViewListIcon className="h-4 w-4" />
      <span className="hidden sm:inline">List</span>
    </button>
  </div>
));

ViewToggle.displayName = "ViewToggle";

export default ViewToggle;
